import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import UIOverlay from 'UIComponents/overlay/UIOverlay';
import UIOverlayContent from 'UIComponents/overlay/UIOverlayContent';
import useCollabGenerateTriggersPrompt from 'automation-ui-canvas/copilot-collaboration/hooks/useCollabGenerateTriggersPrompt';
import { useCanvasTopOffset } from 'automation-ui-canvas/utils/styleUtils';
import { withTransientStyleProps } from 'automation-ui-core/components/TransientStylePropsDecorator';
import { NavMarker } from 'react-rhumb';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledUIOverlay = styled(withTransientStyleProps(UIOverlay)).withConfig({
  displayName: "CollabGenTriggersFlowContent__StyledUIOverlay",
  componentId: "sc-1nyh1jm-0"
})(["top:", "px !important;display:flex;justify-content:center !important;align-items:flex-start;"], props => props.$canvasTopOffset);
const CollabGenTriggersFlowContent = ({
  viewData,
  flow,
  Canvas,
  canvasScrollElementRef
}) => {
  const {
    actionCardPropsById,
    isCopilotReady,
    sendActionFromAppToCopilot
  } = viewData;
  const canvasTopOffset = useCanvasTopOffset(canvasScrollElementRef);
  useCollabGenerateTriggersPrompt({
    isCopilotReady,
    sendActionFromAppToCopilot,
    objectTypeId: flow === null || flow === void 0 ? void 0 : flow.getObjectTypeId()
  });
  return /*#__PURE__*/_jsxs(NavMarker, {
    name: "COLLAB_GEN_TRIGGERS_FLOW",
    children: [!isCopilotReady && /*#__PURE__*/_jsx(StyledUIOverlay, {
      use: "dark",
      width: "100%",
      $canvasTopOffset: canvasTopOffset,
      centerContent: false,
      children: /*#__PURE__*/_jsx(UIOverlayContent, {
        children: /*#__PURE__*/_jsx(UILoadingSpinner, {
          showLabel: true
        })
      })
    }), /*#__PURE__*/_jsx(Canvas, {
      flow: flow,
      actionCardPropsById: actionCardPropsById
    })]
  });
};
export default CollabGenTriggersFlowContent;